import React from "react";
import CustomAddEditAddress from "../../../../CustomComponents/CustomAddEditAddress";

const EditAddress = () => {
  return (
    <>
      <CustomAddEditAddress headerText="Edit Address" buttonText="Update" />
    </>
  );
};

export default EditAddress;
